module.exports = __webpack_public_path__ + "media/scholarship_winners/zachary-l-2138b891.png";